import { Modal } from "../common/Modal";
import { InlineAISetup } from "./InlineAISetup";
import styles from "./AISetupModal.module.css";

interface AISetupModalProps {
  onClose: () => void;
  onConfigured?: () => void;
}

export function AISetupModal({ onClose, onConfigured }: AISetupModalProps) {
  return (
    <Modal onClose={onClose} labelledBy="ai-setup-title" className={styles.modal}>
      <div className={styles.header}>
        <h3 id="ai-setup-title" className={styles.title}>
          Connect AI Provider
        </h3>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
          <CloseIcon />
        </button>
      </div>
      <p className={styles.description}>
        Connect an AI provider to enable smart features like outline generation and real-time
        writing suggestions.
      </p>
      <InlineAISetup onConfigured={onConfigured} />
    </Modal>
  );
}

function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4L12 12M12 4L4 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
